var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.comp)?_c('div',[_c(_vm.comp,_vm._b({tag:"component"},'component',{stats: _vm.getStats()},false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }